import { constants } from 'common/helpers'


const {
  cosmeticsProductTypes: {
    skincare,
    skincare: {
      eye,
      lip,
      mens,
    },
  },
  productsFeed,
  productTypeGroups,
} = constants

const tags = [ 'eye', 'lip', 'face', 'personalCare' ]

const gqlQueryParams = {
  eye: [
    {
      groups: [ productTypeGroups.skincare ],
      productsFeed: productsFeed.eye,
      types: Object.keys(eye).map((key) => eye[key]),
    },
    {
      groups: [ productTypeGroups.skincare ],
      productsFeed: productsFeed.mens,
      types: [ mens.eye ],
    },
  ],
  lip: [
    {
      groups: [ productTypeGroups.skincare ],
      productsFeed: productsFeed.bodyWashes,
      types: Object.keys(lip).map((key) => lip[key]),
    },
  ],
  face: [
    {
      groups: [ productTypeGroups.skincare ],
      productsFeed: productsFeed.mens,
      types: [ mens.face, mens.shaving ],
    },
    ...([ 'masks', 'moisturizers', 'treatments', 'cleansers' ].map((faceItem) => ({
      groups: [ productTypeGroups.skincare ],
      productsFeed: productsFeed[faceItem],
      types: Object.keys(skincare[faceItem]).map((key) => skincare[faceItem][key]),
    }))),
  ],
  personalCare: [
    {
      groups: [ productTypeGroups.personalCare ],
      productsFeed: productsFeed.bodyWashes,
    },
  ],
}

const gqlParams = tags.reduce((result, tag) => ([
  ...result,
  ...gqlQueryParams[tag].map((params) => ({
    ...params,
    // custom name is a unique identifier for gql request, kinda ductape
    customName: `${tag}_${params.productsFeed}`,
  })),
]), [])


export default gqlParams
